export default __webpack_public_path__ + "static/judgmental-99b178c1392a25fe8bcfed65c6f5360a.svg";